import {
  handleFetch,
  POST_OPTIONS,
  GET_OPTIONS,
  PUT_OPTIONS,
} from "./base.service";

const BASE_PATH = "/semester";

export const findSemesterById = async (id) => {
  return await handleFetch(`${BASE_PATH}/id/${id}`, GET_OPTIONS);
};

export const findAllSemester = async () => {
  return await handleFetch(`${BASE_PATH}/all`, GET_OPTIONS);
};

export const findAllActiveSemester = async () => {
  return await handleFetch(`${BASE_PATH}/all/active`, GET_OPTIONS);
};

export const createSemester = async (body) => {
  return await handleFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
};

export const editSemester = async (id, body) => {
  return await handleFetch(`${BASE_PATH}/edit/${id}`, PUT_OPTIONS, body);
};

export const findAllSemesterPaged = async (page, limit) => {
  return await handleFetch(
    `${BASE_PATH}/all-paged/${page}/${limit}`,
    GET_OPTIONS,
  );
};

export const deleteSemester = async (id) => {
  return await handleFetch(`${BASE_PATH}/delete/${id}`, PUT_OPTIONS);
};

export const activateSemester = async (id) => {
  return await handleFetch(`${BASE_PATH}/activate/${id}`, PUT_OPTIONS);
};
